import { render, staticRenderFns } from "./OwnerSelector.vue?vue&type=template&id=20ef91d1"
import script from "./OwnerSelector.vue?vue&type=script&lang=js"
export * from "./OwnerSelector.vue?vue&type=script&lang=js"
import style0 from "./OwnerSelector.vue?vue&type=style&index=0&id=20ef91d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports